import { JsonProperty } from '../../../models/utilities/json-property';
import { DISABLE_REASON } from '../../../models/utilities/type-models';
import { OrderProductionStatus } from "../../../models/ordering/enums/order-production-status";
import { OrderStatus } from "../../../models/ordering/enums/order-status";
import { ShipmentMethod } from '../enums/shipment-method';

export class OrderSummary {
    
    public id               : string = '';

    public dealerId         : string = '';
    
    public dealerName       : string = '';
    
    public serviceCenterId  : string = '';
    
    public status           : OrderStatus = OrderStatus.Cancelled;

    public productionStatus : OrderProductionStatus = OrderProductionStatus.NotApplicable;

    @JsonProperty({toType: 'date'})
    public cutoffDate       : Date|undefined = undefined;

    public shippingMethod   : ShipmentMethod = ShipmentMethod.Delivery;
    
    public pOName           : string = '';

    public jobName          : string = '';

    public groupId          : number = 0;

    public quantity         : number = 0;

    public description      : string = '';

    public amount           : number = 0.00;

    public weight           : number = 0;

    public units            : number = 0;

    public singles          : number = 0;

    public doors            : number = 0;

    public sections         : number = 0;

    public longSections     : number = 0;

    public track            : number = 0;

    public hardware         : number = 0;

    public feet             : number = 0;

    public lineNumber?      : number|undefined = undefined;

    public paymentTermId    : string = '';
    
    @JsonProperty({toType: 'datetime'})
    public lastModified     : Date = new Date();

    public rowVersion       : string = '';
    
    // TODO: These fields are only currently used in the COD flyout.  But OrderSummary
    // is used in a lot of places throughout transportation.  This can be confusing for
    // a new person that won't know whether to use total or amount.
    // COD Related Fields
    public subtotal         : number = 0.00;
    public tax              : number = 0.00;
    public total            : number = 0.00;

    // UI Property
    public isDisabled       : boolean = false;
    public disabledReason   : DISABLE_REASON = undefined;
    public isChecked        : boolean = false;
    
}
